module.exports = {
  analytics: {
    id: 'UA-75443398-1'
  },
  api: {
    base_url: '/wp-json/wp/v2',
    acf: {
      options: '/wp-json/acf/v2/options'
    },
    posts_per_page: 10,
    home: {
      posts_per_page: 1
    }
  },
  contact: {
    email: 'support@sukoyaka2015.jp',
    phone: "052-709-3800",
    fax: "052-709-3801"
  },
  gmap: {
    markerIcon: {
      path: 'M48,16c-8.3,0-15,6.6-15,14.7C33,41.7,48,58,48,58s15-16.3,15-27.3C63,22.6,56.3,16,48,16z M48,36c-3,0-5.4-2.3-5.4-5.2 c0-2.9,2.4-5.2,5.4-5.2s5.4,2.3,5.4,5.2C53.4,33.6,51,36,48,36z',
      fillOpacity: 1,
      strokeWeight: 0,
      fillColor: '#5B8ECE',
      anchor: new google.maps.Point(50, 60)
    }
  },
  titles: {
    titleTemplate: '%s | NPO法人健やかネットワーク',
    about: '健やかネットワークについて',
    entry: '入会のご案内',
    recruit: '求人情報',
    news: 'お知らせ',
    links: 'リンク集',
    home: 'TOP',
    services: {
      nursing_insurance: '介護保険',
      volunteering: '有償ボランティア',
      disability_supports: '障害事業'
    },
    notFound: 'お探しのページは見つかりませんでした。'
  }
};



/** WEBPACK FOOTER **
 ** ./src/data.js
 **/